var map = {
	"./australia.json": 1952,
	"./austria.json": 3589,
	"./belgium.json": 2215,
	"./canada.json": 2728,
	"./czech.json": 9673,
	"./denmark.json": 9192,
	"./finland.json": 870,
	"./france.json": 5733,
	"./germany.json": 9431,
	"./ireland.json": 3249,
	"./israel.json": 2966,
	"./italy.json": 6497,
	"./netherlands.json": 7942,
	"./newzealand.json": 4553,
	"./norway.json": 8868,
	"./poland.json": 6174,
	"./slovakia.json": 8494,
	"./spain.json": 4283,
	"./sweden.json": 3362,
	"./switzerland.json": 3503,
	"./uk.json": 9674,
	"./usa.json": 3705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5049;